import PropTypes from "prop-types";

import { i18n } from "core/i18n";

const { FormattedText } = i18n;

export const ValidationContent = ({ titleText, descriptionText }) => {
    return (
        <div className="container-fluid">
            <div className="row">
            <div className="col-xs-12">
                <h4 className="accountCancelModal-title">
                    <FormattedText value={titleText} />
                </h4>
            </div>
            </div>
            <div className="row">
            <div className="col-xs-12">
                <p className="accountCancelModal-description">
                    <FormattedText value={descriptionText} />
                </p>
            </div>
            </div>
        </div>
    )
}

ValidationContent.propTypes = {
    titleText: PropTypes.string,
    descriptionText: PropTypes.string
};
